import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';
import { Ripple } from "primeng/ripple";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	host: { class: 'partners' },
	standalone: true,
	imports: [
		RouterOutlet,
		ToastModule,
		ConfirmDialogModule,
		SharedModule,
		ButtonModule,
		Ripple,
	],
})
export class AppComponent { }
